import React, { useState } from 'react';
import KorshaLogo from './KorshaLogo';
import useNavScroll from '../hooks/useNavScroll';

const NAV_ITEMS = ['Home', 'About', 'Projects', 'Skills', 'Team', 'Contact'];

const Navbar = ({ navTo }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { scrolled, activeSection } = useNavScroll();

  const handleNav = (id) => {
    navTo(id);
    setMenuOpen(false);
  };

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`} id="navbar">
        <div className="nav-inner container">
          <button className="nav-logo" onClick={() => handleNav('home')} style={{ background: 'none', border: 'none' }}>
            <KorshaLogo size={34} />
            <span className="nav-logo-text">KORSHA</span>
          </button>

          <ul className="nav-links" id="navLinks">
            {NAV_ITEMS.map(item => (
              <li key={item}>
                <button
                  className={`nav-link${activeSection === item.toLowerCase() ? ' active' : ''}`}
                  onClick={() => handleNav(item.toLowerCase())}
                >
                  {item}
                </button>
              </li>
            ))}
          </ul>

          <button className="btn-primary nav-cta" onClick={() => handleNav('contact')}>
            Let's Talk
          </button>

          <button
            className={`nav-hamburger${menuOpen ? ' open' : ''}`}
            id="hamburger"
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div className={`nav-drawer${menuOpen ? ' open' : ''}`} id="navDrawer">
        <ul>
          {NAV_ITEMS.map(item => (
            <li key={item}>
              <button onClick={() => handleNav(item.toLowerCase())}>{item}</button>
            </li>
          ))}
        </ul>
        <button className="btn-primary" onClick={() => handleNav('contact')} style={{ textAlign: 'center' }}>
          Let's Talk
        </button>
      </div>
    </>
  );
};

export default Navbar;
